var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingStrategySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.52 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-4{fill:#d6d8e5;}.cls-1{opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-3{fill:#9ea2b2;}.cls-5{fill:#f4f4f4;}.cls-6{fill:#9acc12;}.cls-7{fill:#e8bc05;}.cls-8{fill:#ef6848;}.cls-9{fill:#be4aed;}.cls-10{fill:#543526;}.cls-11{fill:#1b96ea;}.cls-12{fill:#ff5050;}.cls-13{fill:#32cec3;}.cls-14{fill:none;stroke:#d6d8e5;stroke-miterlimit:10;stroke-width:1.42px;}.cls-15{opacity:0.3;}.cls-16{fill:#dd990e;}.cls-17{fill:#f9cb07;}.cls-18{fill:#cc8b09;}.cls-19{fill:#e8a30a;}.cls-20{fill:#f9ca06;}.cls-21{fill:#3a2c6d;}.cls-22{fill:#ffcea9;}.cls-23{fill:#38226d;}.cls-24{fill:#2f55d4;}.cls-25{fill:#2f55d4;}.cls-26{fill:#ededed;}.cls-27{fill:#d33d3d;}.cls-28{fill:#ff4d4d;}.cls-29{fill:#2b303f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Marketing_strategy_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "257.6 344.8 244.41 337.57 256.12 330.81 269.31 338.04 257.6 344.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "328.52 386.55 315.33 379.31 327.04 372.56 340.22 379.79 328.52 386.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "262.75 341.76 250.31 334.58 289.93 208.02 302.37 215.2 262.75 341.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "270.04 337.74 257.6 330.56 297.22 204 309.65 211.18 270.04 337.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "262.75 341.76 250.31 334.58 289.93 208.02 302.37 215.2 262.75 341.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "343.15 378.39 330.62 371.15 313.51 211.84 325.95 219.03 343.15 378.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "334.44 383.36 321.91 376.12 304.8 216.81 317.24 223.99 334.44 383.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "433.04 284.39 199.3 149.44 209.86 143.34 443.6 278.29 433.04 284.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "433.04 296.56 199.3 161.61 199.3 149.41 433.04 284.36 433.04 296.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "428.31 275.24 213.06 150.96 213.06 0 428.31 124.28 428.31 275.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "443.77 290.37 433.04 296.56 433.04 284.17 443.77 277.98 443.77 290.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "246.74 44.98 228.91 34.69 228.91 27.83 246.74 38.12 246.74 44.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.69 67.47 254.33 49.37 254.33 42.5 285.69 60.61 285.69 67.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "246.74 57.94 228.91 47.65 228.91 40.79 246.74 51.08 246.74 57.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.69 80.43 254.33 62.33 254.33 55.46 285.69 73.57 285.69 80.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "246.74 72.81 228.91 62.52 228.91 55.65 246.74 65.95 246.74 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.69 95.3 254.33 77.19 254.33 70.33 285.69 88.44 285.69 95.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "246.74 87.68 228.91 77.38 228.91 70.52 246.74 80.81 246.74 87.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.69 110.17 254.33 92.06 254.33 85.2 285.69 103.31 285.69 110.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.85,83.22c3.95-5.1,11-5.92,19.1-1.26.78.45,1.55.94,2.3,1.46L328,107.88,308.78,83.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M348.93,110.79l-21-2.91,2.3-24.46C338.83,89.39,346,100.11,348.93,110.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.4,120.84c0,11-6,17-14.37,15.91L328,107.88l21,2.91A37.38,37.38,0,0,1,350.4,120.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.78,83.32c-2.08,2.73-3.28,6.66-3.28,11.6,0,14.32,10.05,31.72,22.45,38.88a22.18,22.18,0,0,0,8.07,2.94L328,107.88l-19.1-24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M370.92,119.06c3.95-5.1,11-5.92,19.1-1.27.78.45,1.54.94,2.3,1.47L390,143.72l-19.18-24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M411,146.62l-21-2.9,2.3-24.46C400.9,125.22,408.06,135.94,411,146.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M412.47,156.68c0,11-6,17-14.37,15.9L390,143.72l21,2.9A37.91,37.91,0,0,1,412.47,156.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M370.84,119.15c-2.07,2.74-3.27,6.66-3.27,11.6,0,14.32,10.05,31.73,22.45,38.89a22,22,0,0,0,8.07,2.93L390,143.72l-19.1-24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M308.78,190.59s15.21-29,53.84,8,48.38,8.3,48.38,8.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 341.65,
    cy: 182.98,
    rx: 2.63,
    ry: 4.55,
    transform: "translate(-45.72 195.35) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 314.33,
    cy: 182.93,
    rx: 2.63,
    ry: 4.55,
    transform: "translate(-49.35 181.68) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 370.84,
    cy: 205.08,
    rx: 2.63,
    ry: 4.55,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -52.85, 212.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 403.73,
    cy: 215.1,
    rx: 2.63,
    ry: 4.55,
    transform: "translate(-53.46 230.69) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "235.01 149.34 228.91 145.81 228.91 124.65 235.01 128.18 235.01 149.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.91 159.09 245.8 155.56 245.8 126.97 251.91 130.5 251.91 159.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "268.8 168.84 262.69 165.32 262.69 124.34 268.8 127.86 268.8 168.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.69 178.59 279.58 175.07 279.58 124.18 285.69 127.7 285.69 178.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "334.44 383.36 343.15 378.39 332.72 367.45 334.44 383.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "262.75 341.76 270.04 337.74 267.24 327.42 262.75 341.76"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 404.91,
    cy: 469.14,
    rx: 43.61,
    ry: 25.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-21",
    d: "M402.91,207.24c1.95-3.13,16.84-5.19,21.74,7.43,1.86,4.78,1.57,17,3.12,24.69s5.22,12,6.53,18.27-.83,16.69-15.85,18.53-26.57-3.43-30.12-8.22-3.62-15,.07-20.43,6.48-9.91,6.39-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M385.07,260s-3.53,24.9,3.14,42.6,4.82-4.56,4.82-4.56l-1.6-5.29s-1.34-20.36-.79-25.35.42-9.28.79-9.68-1.33-1.19-2-1.29S385.07,260,385.07,260Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-21",
    d: "M412.74,205.06s-11.21-3.23-18,2.83c-6.21,5.54-5.69,13.08-4.79,16.62s2.72,8.37,5.53,8.64S412.74,205.06,412.74,205.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M417,235.64s-.74,12.5-.51,13.42,4.91,1.8,6.22,2.89-6.8,13.77-10.92,15.65-16.89-2.92-17.77-9.27c-.82-5.85,3.65-10.39,5.37-12a28.24,28.24,0,0,1,3.52-.09l.38-6.06C408.91,238.43,417,235.64,417,235.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-5",
    d: "M418.74,250.27c3.51.54,7.53,2.42,8.08,4.34.64,2.24,2,12.81-1,20.86s-5.09,13.16-6.83,16.62c0,0-15.19,6.52-27.44-1.08,0,0-.84-8.62-.9-13.23-11.3-9.86-1.64-22,7.94-31.47a19.92,19.92,0,0,1,3.45-.05s-8.55,10.11-2.61,15.85C412.14,258.26,414.67,252.55,418.74,250.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M393.68,220.16h0c1.26-8,7.06-14.1,15.34-13.61a15.91,15.91,0,0,1,8,29.09,15.79,15.79,0,0,1-1.28,3.51c-2.94,3.42-10.72,5.58-13.29,5.62-2.23,0-4.14-2.05-6.23-5.5C391.9,232.08,393,224.12,393.68,220.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M411.59,206.7c5.81,1.13,10.58,2.77,12.16,8.47,1.08,3.93,2.49,11.41,1.15,14.57l-.84,2.28-7,3.62s-3.28-2.73-2.26-10.75a5.7,5.7,0,0,0-1-3,8.63,8.63,0,0,1-1-2.42,9,9,0,0,0-4.56-4.93c-5.23-2.94-12.9-.4-14,.66C397.81,207.9,404.83,205.38,411.59,206.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M422.14,459.79c-2.94,2.39-7.51.74-7.73.95-3,3-7.45,5.61-10.77,8.23-1.83,1.44-4.68,3.37-4.17,6.14.93,4.95,8.86,3.43,11.85,1.91s5.43-4,8.26-5.78c2-1.26,4-1.91,4.32-4.46C424.09,465.24,422.66,459.73,422.14,459.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M423.86,465.76c-.39,2.44-2.35,3.11-4.35,4.35-2.88,1.79-5.41,4.37-8.4,5.88-2.76,1.4-9.66,2.79-11.6-.74,1.06,4.77,8.85,3.27,11.81,1.77s5.43-4,8.26-5.78c2-1.26,4-1.91,4.32-4.46A4.69,4.69,0,0,0,423.86,465.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M401.52,455.67c-2.69,2.19-6.75,1-6.95,1.16-2.74,2.75-6.8,5.11-9.84,7.5-1.68,1.32-4.3,3.09-3.83,5.62.85,4.54,8.11,3.14,10.85,1.76s5-3.69,7.57-5.3c1.85-1.15,3.67-1.75,4-4.08C403.45,460.92,402,455.61,401.52,455.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M403.24,461.39c-.35,2.23-2.15,2.85-4,4-2.64,1.64-5,4-7.7,5.38-2.53,1.29-8.84,2.56-10.62-.68,1,4.37,8.1,3,10.81,1.63s5-3.69,7.57-5.3c1.85-1.15,3.67-1.75,4-4.08A4,4,0,0,0,403.24,461.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M385.68,318.94c1.29-10.13,5-24.85,5-24.85A29.85,29.85,0,0,0,402,296.88c6.54.33,17-1.65,17-1.65a104.44,104.44,0,0,0,6,9.27c2.92,4.05,8.6,12.94,7.23,28.47-.9,10.15-6.58,53.24-6.58,53.24a80.57,80.57,0,0,1,3.49,22.35c-.06,6.27-1.71,16.92-3.56,26.77l-3.39,24.46s-4.51,3.26-7.73.95l.41-23.93c-.4-5.86-1-14.5-1.35-20-.61-9-2.22-23.26-2.68-26.83s-1.61-9.79-2.15-16.77-3.18-42.45-3.18-42.45l-.36,6.64s-.35,10.79-1.9,24.09-2.09,19.21-2.09,19.21,2.69,4.95,3,8.59c.27,2.88,3.56,25.63,1.6,37.2l-4,29.42a7.73,7.73,0,0,1-7,.92l-2.37-29.65c-1.59-11.29-5-35.21-5.48-38.32-.68-4.09-1.24-6.11-2-19S384.38,329.07,385.68,318.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M419,292.09l8.72,17.53s13.32,19.49-.48,69.6l2.59,15.46s-26.12,16.76-43.6,0c0,0-6.06-46.31-2.84-67.66a246,246,0,0,1,8.14-36.28s4.28,4.73,26.31,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M364.34,304.54c2,.38,3.91-.05,6.71.71a21.45,21.45,0,0,0,6.47,1c2.38,0,9.06-3.33,14.79-7.35,6.75-4.73,13.45-12.9,15.87-16.83,5.21-8.48,10.2-17.23,11.74-21.71,1.84-5.38,1.8-1.72,5-1.8,3.73-.09,5.74,1.28,2.94,8.58s-5.35,12.38-11.59,21a69.09,69.09,0,0,1-16.69,16.66,86.71,86.71,0,0,1-18.32,9.79c-1.87.77-3.06,1.8-6.45,3.68a24,24,0,0,1-11,3.16c-3.24-.08-4.4-.62-4.67-1.28-.34-.83.29-1.4,1.77-1.54a19.57,19.57,0,0,0,6.91-1.37s-3.23.46-5.18.56a19.62,19.62,0,0,1-5.19-.41c-1.64-.39-2.56-2.71-1.07-2.89s2.69.1,5.59-.09a19.39,19.39,0,0,0,4.52-.83,35.71,35.71,0,0,1-5.79-.42,8.13,8.13,0,0,1-4.27-1.71c-.63-.52-.74-2,1.14-2,1.69,0,3.81.78,7,.34,2.35-.33,4-.88,3.6-1.19s-1.73,0-3.67-.71-3.3-2.41-2.85-3.43S362.32,304.17,364.34,304.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M426.13,274.06s-8.55.45-13.41-4.91l5.27-11s2.43-6.09,8.13-4.59S431.91,263.08,426.13,274.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M398.58,246.31s-6.94-2.12-14.31,13.25l2.76,1.66S394.28,250.25,398.58,246.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.1,339,81.5,273.42a6.38,6.38,0,0,1,0-11.05h0a6.38,6.38,0,0,1,6.38,0L201.48,328a6.38,6.38,0,0,1-.73,11.41h0A6.36,6.36,0,0,1,195.1,339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M146.05,299.33c-40.66-23.47-73.73-80.76-73.73-127.7s33.07-66,73.73-42.56,73.73,80.75,73.73,127.7S186.7,322.8,146.05,299.33Zm0-155c-33.38-19.27-60.54-3.59-60.54,34.95s27.16,85.57,60.54,104.84,60.53,3.6,60.53-34.94S179.43,163.57,146.05,144.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "83.82 129.6 97.33 122.22 95.31 131.48 83.82 129.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M185.62,311.28c.33-.15,14.77-8.23,14.77-8.23l-11.16-1.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 136.64,
    cy: 219.42,
    rx: 54.81,
    ry: 94.94,
    transform: "translate(-91.41 97.72) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M136.64,304.56C96,281.08,62.91,223.8,62.91,176.85s33.08-66,73.73-42.56,73.73,80.76,73.73,127.7S177.3,328,136.64,304.56Zm0-155c-33.37-19.27-60.53-3.6-60.53,34.94s27.16,85.58,60.53,104.85,60.54,3.59,60.54-34.95S170,168.8,136.64,149.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M136.64,272.16C111.46,257.62,91,222.13,91,193.05s20.49-40.91,45.67-26.37,45.68,50,45.68,79.11S161.83,286.71,136.64,272.16Zm0-90.24c-17.91-10.34-32.48-1.93-32.48,18.75s14.57,45.92,32.48,56.26,32.48,1.92,32.48-18.76S154.55,192.26,136.64,181.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M136.64,240.28c-10-5.75-18.06-19.79-18.06-31.29s8.1-16.18,18.06-10.43,18.07,19.79,18.07,31.29S146.61,246,136.64,240.28Zm0-26.48c-2.68-1.55-4.87-.29-4.87,2.81a10.79,10.79,0,0,0,4.87,8.43c2.69,1.55,4.87.29,4.87-2.81A10.76,10.76,0,0,0,136.64,213.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "11.02 290.9 4.26 290.99 26.22 281.67 13.49 289.58 11.02 290.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 12.75,
    cy: 291.9,
    rx: 1.41,
    ry: 2.44,
    transform: "translate(-144.25 45.49) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 136.96,
    cy: 220.03,
    rx: 1.41,
    ry: 2.44,
    transform: "translate(-91.67 97.97) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "15.64 300.69 14.03 293.96 31.69 282.7 30.92 284.29 15.64 300.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M14,294c.15-.13,124.15-71.81,124.15-71.81l-2.28-4.3-124.38,72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingStrategySvg);
export default __webpack_public_path__ + "static/media/Marketing_strategy_SVG.4cdbaebcca6d603c37aacc63dfd487a6.svg";
export { ForwardRef as ReactComponent };